import React from "react";
import {IShow3DOptions} from "../components/visualizer/VisualizerSessionManager";
import {IOptionSetRequest} from "../unreal_api/UnrealClient";
import {IMessageSender} from "./UnrealSignalRVisualizer";




export interface IVisualizerManager {
    browse(sessionId:string, uri:string): void;
    playVideo(sessionId:string, file: string, looping: boolean): void;
    changeCamera(cameraId:string):void;
    connect(): Promise<void>;
    getMessageSender(): IMessageSender;

    /**
     * Verifies connection to the visualizer. If everything works, returns null. If there is an issue, returns the error message.
     */
    verifyConnection(): Promise<string | null>;

    sendOptions(req: IOptionSetRequest): void;
}
export interface IShow3dVisualizer {
    show3d(sessionId:string, options: IShow3DOptions): void;

}

export function is3dVisualizer(vis: IVisualizerManager): vis is IShow3dVisualizer & IVisualizerManager {
    if ((vis as any)["show3d"] !== undefined) {
        return true;
    }
    return false;
}

const VisualizerContext = React.createContext<IVisualizerManager|null>(null);
//export default VisualizerContext;

